import React, { Component } from 'react'
import styled from 'styled-components'

import FeedbackContent from 'components/FeedbackContent'

/**
 * Página isolada do inquérito de satisfação.
 *
 * Renderiza APENAS o conteúdo (FeedbackContent) — formulário + painel verde —
 * sem a moldura de modal, porque a ideia é este conteúdo ser colocado dentro
 * de uma modal do projeto pai (ex.: embebido num iframe como micro-serviço).
 *
 * Aqui, para efeitos de visualização/teste isolado, envolvemos o conteúdo numa
 * caixa centrada com dimensões semelhantes às da modal original. No projeto
 * pai é a modal desse projeto que define o contentor/dimensões.
 *
 * Montada através do id `adene-simulador-feedback` (ver index.js / index.html).
 * A FeedbackModalV2 mantém-se intacta para uso dentro desta aplicação.
 */
export default class FeedbackStandalone extends Component {
  state = {
    width: window.innerWidth,
    submitted: false,
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ width: window.innerWidth })
  }

  // A lógica de submissão chama onClose apenas após o POST ter sucesso.
  // Sem botão Cancelar, isto corresponde exclusivamente a "submetido com sucesso":
  // avisamos o projeto pai (para poder esconder a modal/iframe) e mostramos
  // a confirmação.
  handleSubmitted = () => {
    window.parent.postMessage({ type: 'submitted' }, '*')
    this.setState({ submitted: true })
  }

  render() {
    const { width, submitted } = this.state

    return (
      <Page>
        {submitted ? (
          <ThankYou>Obrigado pelo seu feedback.</ThankYou>
        ) : (
          <Box>
            <FeedbackContent width={width} onClose={this.handleSubmitted} />
          </Box>
        )}
      </Page>
    )
  }
}

const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
`

const Box = styled.div`
  width: 100%;
  max-width: 800px;
  height: 560px;
  background: #fff;

  @media (max-width: 999px) {
    height: auto;
  }
`

const ThankYou = styled.p`
  font-family: Nunito;
  font-size: 18px;
  font-weight: 700;
  color: #1d1e22;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/containers/FeedbackStandalone/index.js